"use strict";

exports.broadcastTypesHash = {
  concert: 'concert',
  lecture: 'lecture',
  discussion: 'discussion',
  excursion: 'excursion',
  performance: 'performance',
  movie: 'movie',
  videoExcursion: 'videoExcursion',
  webinar: 'webinar',
  masterClass: 'masterClass',
  presentation: 'presentation',
  award: 'award',
  festival: 'festival',
  concurs: 'concurs'
};
exports.broadcastTypeTitlesHash = {
  concert: 'Концерт',
  lecture: 'Лекция',
  discussion: 'Дискуссия',
  excursion: 'Экскурсия',
  performance: 'Спектакль',
  movie: 'Кино',
  videoExcursion: 'Видеоэкскурсия',
  webinar: 'Вебинар',
  masterClass: 'Мастер-класс',
  presentation: 'Презентация',
  award: 'Премия',
  festival: 'Фестиваль',
  concurs: 'Конкурс'
};
exports.broadcastTypePluralTitlesHash = {
  concert: 'Концерты',
  lecture: 'Лекции',
  discussion: 'Дискуссии',
  excursion: 'Экскурсии',
  performance: 'Спектакли',
  movie: 'Кино',
  videoExcursion: 'Видеоэкскурсии',
  webinar: 'Вебинары',
  masterClass: 'Мастер-классы',
  presentation: 'Презентации',
  award: 'Премии',
  festival: 'Фестивали',
  concurs: 'Конкурсы'
};